var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-button',{attrs:{"type":_vm.isPrimary?'primary':'',"loading":_vm.spinning},on:{"click":function($event){return _vm.download()}}},[_c('a-icon',{attrs:{"type":"download"}}),_vm._v(_vm._s(_vm.name)+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }